import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, LoadingContent, Modal } from '../../../components'
import PdcaLayout from '../base/pdcaLayout'
import PdcaPageHeader from '../components/pdcapageheader/pdcapageheader'
import {
  TOOL_LIST,
  closeConnectForm,
  closeDisconnectModal,
  closeReconfigureForm,
  closeReplaceModal,
  connectManualIntegration,
  disconnectIntegration,
  fetchIntegration,
  iniciarOAuthClickup,
  iniciarOAuthTrello,
  openConnectForm,
  openDisconnectModal,
  openReconfigureForm,
  openReplaceModal,
  reconfigureManualIntegration,
  validateIntegration
} from './redux/integrationsActions'
import './integrations.scss'

const MASKED_TOKEN = '*********************'

const TOOL_UI = {
  asana: {
    code: 'asana',
    label: 'Asana',
    shortLabel: 'A',
    type: 'manual',
    className: 'asana'
  },
  trello: {
    code: 'trello',
    label: 'Trello',
    shortLabel: 'T',
    type: 'oauth',
    className: 'trello'
  },
  clickup: {
    code: 'clickup',
    label: 'ClickUp',
    shortLabel: 'C',
    type: 'oauth',
    className: 'clickup'
  },
  monday: {
    code: 'monday',
    label: 'Monday.com',
    shortLabel: 'M',
    type: 'manual',
    className: 'monday'
  },
  jira: {
    code: 'jira',
    label: 'Jira Cloud',
    shortLabel: 'J',
    type: 'manual',
    className: 'jira'
  }
}

const MANUAL_TOOLS_ENABLED = ['asana', 'monday', 'jira']
const OAUTH_TOOLS_ENABLED = ['trello', 'clickup']

const obterToolUi = toolCode => TOOL_UI[toolCode] || {
  code: toolCode || 'unknown',
  label: toolCode || '-',
  shortLabel: '?',
  type: 'manual',
  className: ''
}

const formatarData = valor => {
  if (!valor) return null

  const data = new Date(valor)

  if (Number.isNaN(data.getTime())) {
    return valor
  }

  return data.toLocaleString()
}

const obterEstadoInicialConnectForm = toolCode => {
  if (toolCode === 'jira') {
    return {
      token: '',
      baseUrl: '',
      username: '',
      apiToken: ''
    }
  }

  return {
    token: '',
    baseUrl: '',
    username: '',
    apiToken: ''
  }
}

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const {
    projetoId,
    empresaPdcaExiste,
    contextoCarregado
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const {
    integration = null,
    loading = false,
    loaded = false,
    error = null,
    validationStatus = null,
    isConnectFormOpen = false,
    connectToolCode = null,
    isReconfigureFormOpen = false,
    isReplaceModalOpen = false,
    replaceTargetToolCode = null,
    isDisconnectModalOpen = false,
    isSubmitting = false,
    submitActionType = null
  } = useSelector(state => state.pdcaState.pdcaIntegrationsState || {})

  const [connectForm, setConnectForm] = useState(obterEstadoInicialConnectForm(null))
  const [reconfigureForm, setReconfigureForm] = useState(obterEstadoInicialConnectForm(null))

  const contextoValido =
    contextoCarregado &&
    String(projetoId) === String(idProjetos)

  const contextoInconsistente = contextoCarregado && !empresaPdcaExiste

  const hasIntegration = !!integration?.existeIntegracao
  const activeToolCode = integration?.ferramentaCodigo || null
  const activeToolUi = hasIntegration ? obterToolUi(activeToolCode) : null

  const availableTools = useMemo(() => {
    if (!hasIntegration) {
      return TOOL_LIST
    }

    return TOOL_LIST.filter(tool => tool.code !== activeToolCode)
  }, [hasIntegration, activeToolCode])

  const subtitle = hasIntegration
    ? nls.pageSubtitleWithIntegration
    : nls.pageSubtitleNoIntegration

  const mostrarStatusInvalido = hasIntegration && validationStatus === 'invalid'
  const mostrarUltimaValidacao = !!integration?.tokenValidadoEm
  const activeIsManualEnabled = MANUAL_TOOLS_ENABLED.includes(activeToolCode)

  

  const activeCanValidateAndDisconnect =
  activeIsManualEnabled || activeToolCode === 'trello' || activeToolCode === 'clickup'


  useEffect(() => {
    if (!idProjetos || !contextoValido || !empresaPdcaExiste) return

    dispatch(fetchIntegration(idProjetos))
  }, [
    dispatch,
    idProjetos,
    contextoValido,
    empresaPdcaExiste
  ])

  const resetConnectForm = toolCode => {
    setConnectForm(obterEstadoInicialConnectForm(toolCode))
  }

  const resetReconfigureForm = toolCode => {
    setReconfigureForm(obterEstadoInicialConnectForm(toolCode))
  }

  const handleAbrirConnect = toolCode => {
  if (OAUTH_TOOLS_ENABLED.includes(toolCode)) {
    if (hasIntegration) {
      dispatch(openReplaceModal(toolCode))
      return
    }

    if (toolCode === 'trello') {
      dispatch(iniciarOAuthTrello({ projetoId: idProjetos, nls }))
    }

    if (toolCode === 'clickup') {
      dispatch(iniciarOAuthClickup({ projetoId: idProjetos, nls }))
    }

    return
  }

  resetConnectForm(toolCode)

  if (hasIntegration) {
    dispatch(openReplaceModal(toolCode))
    return
  }

  dispatch(openConnectForm(toolCode))
}

  const handleConfirmarSubstituicao = () => {
  dispatch(closeReplaceModal())

  if (!replaceTargetToolCode) return

  if (replaceTargetToolCode === 'trello') {
    dispatch(iniciarOAuthTrello({ projetoId: idProjetos, nls }))
    return
  }

  if (replaceTargetToolCode === 'clickup') {
    dispatch(iniciarOAuthClickup({ projetoId: idProjetos, nls }))
    return
  }

  if (MANUAL_TOOLS_ENABLED.includes(replaceTargetToolCode)) {
    resetConnectForm(replaceTargetToolCode)
    dispatch(openConnectForm(replaceTargetToolCode))
  }
}

  const handleCancelarConnect = () => {
    resetConnectForm(connectToolCode)
    dispatch(closeConnectForm())
  }

  const handleCancelarReconfigure = () => {
    resetReconfigureForm(activeToolCode)
    dispatch(closeReconfigureForm())
  }

  const handleAbrirReconfigure = () => {
    if (!activeIsManualEnabled) return

    resetReconfigureForm(activeToolCode)
    dispatch(openReconfigureForm())
  }

  const handleChangeConnectField = (field, value) => {
    setConnectForm(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const handleChangeReconfigureField = (field, value) => {
    setReconfigureForm(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const connectFormValido = () => {
    if (connectToolCode === 'jira') {
      return (
        connectForm.baseUrl.trim() &&
        connectForm.username.trim() &&
        connectForm.apiToken.trim()
      )
    }

    return connectForm.token.trim()
  }

  const reconfigureFormValido = () => {
    if (activeToolCode === 'jira') {
      return (
        reconfigureForm.baseUrl.trim() &&
        reconfigureForm.username.trim() &&
        reconfigureForm.apiToken.trim()
      )
    }

    return reconfigureForm.token.trim()
  }

  const handleConectarManual = () => {
    if (!connectToolCode || !connectFormValido()) return

    dispatch(connectManualIntegration({
      projetoId: idProjetos,
      toolCode: connectToolCode,
      tokenData: connectForm,
      nls
    }))
    resetConnectForm(connectToolCode)
  }

  const handleAtualizarManual = () => {
    if (!activeToolCode || !reconfigureFormValido()) return

    dispatch(reconfigureManualIntegration({
      projetoId: idProjetos,
      toolCode: activeToolCode,
      tokenData: reconfigureForm,
      nls
    }))
    resetReconfigureForm(activeToolCode)
  }

  const handleValidar = () => {
  if (!activeCanValidateAndDisconnect) return

  dispatch(validateIntegration({
    projetoId: idProjetos,
    nls
  }))
}

  const handleAbrirDisconnect = () => {
  if (!activeCanValidateAndDisconnect) return
  dispatch(openDisconnectModal())
}

  const handleConfirmarDisconnect = () => {
  if (!activeCanValidateAndDisconnect) return

  dispatch(disconnectIntegration({
    projetoId: idProjetos,
    nls
  }))
}

  const renderConnectForm = toolCode => {
    if (!toolCode) return null

    const isJira = toolCode === 'jira'

    return (
      <div className='box-pdca-integrations-inline-form'>
        <div className='box-pdca-integrations-inline-form-title'>
          {toolCode === 'asana'
            ? nls.asanaConnectTitle
            : toolCode === 'monday'
              ? nls.mondayConnectTitle
              : nls.jiraConnectTitle}
        </div>

        {isJira ? (
          <>
            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraBaseUrlLabel}</label>
              <input
                type='text'
                value={connectForm.baseUrl}
                onChange={e => handleChangeConnectField('baseUrl', e.target.value)}
                placeholder={nls.jiraBaseUrlPlaceholder}
              />
            </div>

            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraUsernameLabel}</label>
              <input
                type='text'
                value={connectForm.username}
                onChange={e => handleChangeConnectField('username', e.target.value)}
                placeholder={nls.jiraUsernamePlaceholder}
              />
            </div>

            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraApiTokenLabel}</label>
              <input
                type='text'
                value={connectForm.apiToken}
                onChange={e => handleChangeConnectField('apiToken', e.target.value)}
                placeholder={nls.jiraApiTokenPlaceholder}
              />
            </div>
          </>
        ) : (
          <div className='box-pdca-integrations-form-field'>
            <label>{nls.connectTokenLabel}</label>
            <input
              type='text'
              value={connectForm.token}
              onChange={e => handleChangeConnectField('token', e.target.value)}
              placeholder={
                toolCode === 'asana'
                  ? nls.connectTokenPlaceholderAsana
                  : nls.connectTokenPlaceholderMonday
              }
            />
          </div>
        )}

        <div className='box-pdca-integrations-actions'>
          <Button
            color='primary'
            onClick={handleConectarManual}
            disabled={isSubmitting || !connectFormValido()}
          >
            {submitActionType === 'connect'
              ? `${nls.connect}...`
              : nls.connect}
          </Button>

          <Button
            color='default'
            onClick={handleCancelarConnect}
            disabled={isSubmitting}
          >
            {nls.cancel}
          </Button>
        </div>
      </div>
    )
  }

  const renderReconfigureForm = () => {
    if (!activeToolCode) return null

    const isJira = activeToolCode === 'jira'

    return (
      <div className='box-pdca-integrations-inline-form'>
        <div className='box-pdca-integrations-inline-form-title'>
          {activeToolCode === 'asana'
            ? nls.asanaReconfigureTitle
            : activeToolCode === 'monday'
              ? nls.mondayReconfigureTitle
              : nls.jiraReconfigureTitle}
        </div>

        {isJira ? (
          <>
            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraBaseUrlLabel}</label>
              <input
                type='text'
                value={reconfigureForm.baseUrl}
                onChange={e => handleChangeReconfigureField('baseUrl', e.target.value)}
                placeholder={nls.jiraBaseUrlPlaceholder}
              />
              <div className='box-pdca-integrations-form-hint'>
                {nls.tokenSecurityHint}
              </div>
            </div>

            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraUsernameLabel}</label>
              <input
                type='text'
                value={reconfigureForm.username}
                onChange={e => handleChangeReconfigureField('username', e.target.value)}
                placeholder={nls.jiraUsernamePlaceholder}
              />
            </div>

            <div className='box-pdca-integrations-form-field'>
              <label>{nls.jiraApiTokenLabel}</label>
              <input
                type='text'
                value={reconfigureForm.apiToken}
                onChange={e => handleChangeReconfigureField('apiToken', e.target.value)}
                placeholder={nls.jiraApiTokenPlaceholder}
              />
            </div>
          </>
        ) : (
          <div className='box-pdca-integrations-form-field'>
            <label>{nls.newTokenLabel}</label>
            <input
              type='text'
              value={reconfigureForm.token}
              onChange={e => handleChangeReconfigureField('token', e.target.value)}
              placeholder={
                activeToolCode === 'asana'
                  ? nls.newTokenPlaceholderAsana
                  : nls.newTokenPlaceholderMonday
              }
            />
            <div className='box-pdca-integrations-form-hint'>
              {nls.tokenSecurityHint}
            </div>
          </div>
        )}

        <div className='box-pdca-integrations-actions'>
          <Button
            color='primary'
            onClick={handleAtualizarManual}
            disabled={isSubmitting || !reconfigureFormValido()}
          >
            {submitActionType === 'reconfigure'
              ? `${nls.updateConnection}...`
              : nls.updateConnection}
          </Button>

          <Button
            color='default'
            onClick={handleCancelarReconfigure}
            disabled={isSubmitting}
          >
            {nls.cancel}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <PdcaLayout>
      <div className='box-pdca-integrations'>
        <PdcaPageHeader
          title={nls.pageTitle}
          subtitle={subtitle}
        />

        {contextoInconsistente && (
          <div className='box-pdca-integrations-inline-feedback box-pdca-integrations-inline-feedback-error'>
            {nls.contextError}
          </div>
        )}

        {!contextoInconsistente && (
          <LoadingContent loading={loading && !loaded}>
            {error && (
              <div className='box-pdca-integrations-inline-feedback box-pdca-integrations-inline-feedback-error'>
                {error || nls.genericLoadError}
              </div>
            )}

            <>
              <div className='box-pdca-integrations-section-title'>
                <h2>{nls.sectionActiveTitle}</h2>
              </div>

              {hasIntegration ? (
                <div className='box-pdca-integrations-active-card'>
                  <div className='box-pdca-integrations-tool-head'>
                    <div className='box-pdca-integrations-tool-main'>
                      <div className={`box-pdca-integrations-logo ${activeToolUi.className}`}>
                        {activeToolUi.shortLabel}
                      </div>

                      <div>
                        <div className='box-pdca-integrations-tool-name'>
                          {integration?.ferramentaNomeExibicao || activeToolUi.label}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`box-pdca-integrations-status-badge ${
                        mostrarStatusInvalido
                          ? 'box-pdca-integrations-status-badge-warning'
                          : 'box-pdca-integrations-status-badge-success'
                      }`}
                    >
                      {mostrarStatusInvalido ? nls.statusInvalid : nls.statusConnected}
                    </div>
                  </div>

                  <div className='box-pdca-integrations-meta-grid'>
                    <div className='box-pdca-integrations-meta-item'>
                      <div className='box-pdca-integrations-meta-label'>
                        {nls.tokenLabel}
                      </div>
                      <div className='box-pdca-integrations-meta-value'>
                        {MASKED_TOKEN}
                      </div>
                    </div>

                    {mostrarUltimaValidacao && (
                      <div className='box-pdca-integrations-meta-item'>
                        <div className='box-pdca-integrations-meta-label'>
                          {nls.validationLabel}
                        </div>
                        <div className='box-pdca-integrations-meta-value'>
                          {formatarData(integration?.tokenValidadoEm)}
                        </div>
                      </div>
                    )}

                    <div className='box-pdca-integrations-meta-item'>
                      <div className='box-pdca-integrations-meta-label'>
                        {nls.connectionTypeLabel}
                      </div>
                      <div className='box-pdca-integrations-meta-value'>
                        {activeToolUi.type === 'manual' ? nls.manualType : nls.oauthType}
                      </div>
                    </div>
                  </div>

                  <div className='box-pdca-integrations-actions'>


                    {activeIsManualEnabled ? (
                    <>
                      {mostrarStatusInvalido ? (
                        <>
                          <Button
                            color='primary'
                            onClick={handleAbrirReconfigure}
                            disabled={isSubmitting}
                          >
                            {nls.reconfigureConnection}
                          </Button>

                          <Button
                            color='default'
                            onClick={handleValidar}
                            disabled={isSubmitting}
                          >
                            {submitActionType === 'validate'
                              ? `${nls.validateConnection}...`
                              : nls.validateConnection}
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            color='default'
                            onClick={handleValidar}
                            disabled={isSubmitting}
                          >
                            {submitActionType === 'validate'
                              ? `${nls.validateConnection}...`
                              : nls.validateConnection}
                          </Button>

                          <Button
                            color='primary'
                            onClick={handleAbrirReconfigure}
                            disabled={isSubmitting}
                          >
                            {nls.reconfigureConnection}
                          </Button>
                        </>
                      )}

                      <Button
                        color='default'
                        onClick={handleAbrirDisconnect}
                        disabled={isSubmitting}
                      >
                        {submitActionType === 'disconnect'
                          ? `${nls.disconnect}...`
                          : nls.disconnect}
                      </Button>
                    </>
                  ) : activeToolCode === 'trello' ? (
                    <>
                      <Button
                        color='default'
                        onClick={handleValidar}
                        disabled={isSubmitting}
                      >
                        {submitActionType === 'validate'
                          ? `${nls.validateConnection}...`
                          : nls.validateConnection}
                      </Button>

                      <Button
                        color='primary'
                        onClick={() => {
                          dispatch(openReplaceModal('trello'))
                        }}
                        disabled={isSubmitting}
                      >
                        {nls.reconfigureConnection}
                      </Button>

                      <Button
                        color='default'
                        onClick={handleAbrirDisconnect}
                        disabled={isSubmitting}
                      >
                        {submitActionType === 'disconnect'
                          ? `${nls.disconnect}...`
                          : nls.disconnect}
                      </Button>
                    </>
                  ) : activeToolCode === 'clickup' ? (
                    <>
                      <Button
                        color='default'
                        onClick={handleValidar}
                        disabled={isSubmitting}
                      >
                        {submitActionType === 'validate'
                          ? `${nls.validateConnection}...`
                          : nls.validateConnection}
                      </Button>

                      <Button
                        color='primary'
                        onClick={() => {
                          dispatch(openReplaceModal('clickup'))
                        }}
                        disabled={isSubmitting}
                      >
                        {nls.reconfigureConnection}
                      </Button>

                      <Button
                        color='default'
                        onClick={handleAbrirDisconnect}
                        disabled={isSubmitting}
                      >
                        {submitActionType === 'disconnect'
                          ? `${nls.disconnect}...`
                          : nls.disconnect}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button color='default' disabled>
                        {nls.comingSoon}
                      </Button>
                      <Button color='default' disabled>
                        {nls.comingSoon}
                      </Button>
                      <Button color='default' disabled>
                        {nls.comingSoon}
                      </Button>
                    </>
                  )}



                  </div>

                  {activeIsManualEnabled && isReconfigureFormOpen && renderReconfigureForm()}
                </div>
              ) : (
                <div className='box-pdca-integrations-empty-card'>
                  <div className='box-pdca-integrations-empty-title'>
                    {nls.emptyTitle}
                  </div>
                  <div className='box-pdca-integrations-empty-description'>
                    {nls.emptyDescription}
                  </div>
                </div>
              )}

              <div className='box-pdca-integrations-section-title'>
                <h2>{nls.sectionAvailableTitle}</h2>
              </div>

              <div className='box-pdca-integrations-grid'>
                {availableTools.map(tool => {
                  const toolUi = obterToolUi(tool.code)
                  const isManualEnabled = MANUAL_TOOLS_ENABLED.includes(tool.code)
                  const isOAuthEnabled = OAUTH_TOOLS_ENABLED.includes(tool.code)
                  const isConnectOpen = isConnectFormOpen && connectToolCode === tool.code

                  return (
                    <div
                      className='box-pdca-integrations-tool-card'
                      key={tool.code}
                    >
                      <div className='box-pdca-integrations-tool-head'>
                        <div className='box-pdca-integrations-tool-main'>
                          <div className={`box-pdca-integrations-logo ${toolUi.className}`}>
                            {toolUi.shortLabel}
                          </div>

                          <div>
                            <div className='box-pdca-integrations-tool-name'>
                              {toolUi.label}
                            </div>
                            <div className='box-pdca-integrations-tool-subtitle'>
                              {nls.notConnected}
                            </div>
                          </div>
                        </div>

                        <div className='box-pdca-integrations-type-badge'>
                          {toolUi.type === 'manual' ? nls.manualType : nls.oauthType}
                        </div>
                      </div>

                      {(!isManualEnabled && !isOAuthEnabled) && (
                        <div className='box-pdca-integrations-tool-note'>
                          {nls.onlyEnabledTools}
                        </div>
                      )}

                      <div className='box-pdca-integrations-actions'>
                        <Button
                          color='primary'
                          onClick={(isManualEnabled || isOAuthEnabled) ? () => handleAbrirConnect(tool.code) : undefined}
                          disabled={(!isManualEnabled && !isOAuthEnabled) || isSubmitting}
                        >
                          {(isManualEnabled || isOAuthEnabled) ? nls.connect : nls.comingSoon}
                        </Button>
                      </div>

                      {isManualEnabled && isConnectOpen && renderConnectForm(tool.code)}
                    </div>
                  )
                })}
              </div>

              <Modal
                name='pdca-integrations-replace'
                title={nls.replaceModalTitle}
                open={isReplaceModalOpen}
                close={() => dispatch(closeReplaceModal())}
                closeText={nls.cancel}
                size='small'
                actions={(
                  <>
                    <Button
                      color='default'
                      onClick={() => dispatch(closeReplaceModal())}
                    >
                      {nls.cancel}
                    </Button>

                    <Button
                      color='primary'
                      onClick={handleConfirmarSubstituicao}
                    >
                      {nls.replaceModalContinue}
                    </Button>
                  </>
                )}
              >
                <div className='box-pdca-integrations-modal-content'>
                  {nls.replaceModalDescription}
                </div>
              </Modal>

              <Modal
                name='pdca-integrations-disconnect'
                title={nls.disconnectModalTitle}
                open={isDisconnectModalOpen}
                close={() => dispatch(closeDisconnectModal())}
                closeText={nls.cancel}
                size='small'
                actions={(
                  <>
                    <Button
                      color='default'
                      onClick={() => dispatch(closeDisconnectModal())}
                    >
                      {nls.cancel}
                    </Button>

                    <Button
                      color='default'
                      onClick={handleConfirmarDisconnect}
                      disabled={isSubmitting}
                    >
                      {submitActionType === 'disconnect'
                        ? `${nls.disconnect}...`
                        : nls.disconnect}
                    </Button>
                  </>
                )}


              >
                <div className='box-pdca-integrations-modal-content'>
                  {nls.disconnectModalDescription}
                </div>
              </Modal>
            </>
          </LoadingContent>
        )}
      </div>
    </PdcaLayout>
  )
}